/*
 * Copyright (c) 2021. American Express Company
 */

export enum LinkColorVariants {
    ERROR = 'error',
    WARNING = 'warning'
}
